import * as React from 'react';
import {useState} from 'react';
import {FieldError} from 'react-hook-form';
import {BgColorsOutlined, CloseOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import classnames from 'classnames';
import {getErrorMessage} from 'helpers/utils';
import {ColorPicker} from './ColorPicker';

type InputAttributes = React.InputHTMLAttributes<HTMLInputElement>;
type InputAttributesWithoutOnChange = Omit<InputAttributes, 'onChange'>;

interface ColorCodeInputProps extends InputAttributesWithoutOnChange {
  label: string;
  error?: FieldError | FieldError[];
  className?: string;
  value?: string;
  onChange?: (value: string) => void;
}

export const ColorCodeInput: React.FunctionComponent<ColorCodeInputProps> = (props) => {
  const {id, className, label, error, onChange, value, required, ...inputProps} = props;

  const errorMessage = error ? getErrorMessage(error, label) : null;

  const [colorPickerOpen, setColorPickerOpen] = useState(false);

  return (
    <div className="text-input-wrapper">
      <label htmlFor={id}>
        {label} {required && <span>*</span>}
      </label>
      <div className="relative">
        <input
          id={id}
          className={classnames(errorMessage ? 'text-input--error' : 'text-input', className)}
          autoComplete="on"
          type="text"
          {...inputProps}
        />
        <div
          className="absolute h-11 top-0 left-0 right-0 pr-1 pl-2 flex items-center gap-2 cursor-pointer"
          onClick={() => setColorPickerOpen((prev) => !prev)}
        >
          {<div className="h-6 w-full shadow-md" style={{backgroundColor: value ?? 'white'}} />}
          <Button
            type="link"
            icon={colorPickerOpen ? <CloseOutlined className="text-lg" /> : <BgColorsOutlined className="text-lg" />}
          />
        </div>
        {colorPickerOpen && (
          <div className="absolute right-0 z-10">
            <ColorPicker
              onChange={(color: string) => {
                onChange && onChange(color);
                setColorPickerOpen(false);
              }}
              value={value}
            />
          </div>
        )}
      </div>
      {errorMessage && <p className="input-error-message">{errorMessage}</p>}
    </div>
  );
};
